import { render, staticRenderFns } from "./BigConsumerSettings.vue?vue&type=template&id=94d8c08a&scoped=true&"
import script from "./BigConsumerSettings.vue?vue&type=script&lang=ts&"
export * from "./BigConsumerSettings.vue?vue&type=script&lang=ts&"
import style0 from "./BigConsumerSettings.vue?vue&type=style&index=0&id=94d8c08a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d8c08a",
  null
  
)

export default component.exports